import Cookies from 'universal-cookie';

const cookies = new Cookies()

export function appToken(): string {
  return `Bearer ${cookies.get('token_auth')}`
}
